import * as React from 'react';
import { Prompt } from 'react-router';
import { reduxForm } from 'redux-form';
import { compose, withProps } from 'recompose';
import { get } from 'lodash';
import { Card } from 'material-ui/Card';

import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { MyRequestsFormBasic } from '@modules/requests/my-requests/myRequestsFormBasic';

import { getRequest } from '@modules/requests/_requestsActions';
import * as T from '@modules/requests/_requestsTypes';
import { myRequestsLabel, myRequestsPath } from './myRequestsGrid';

export const enhance = compose<T.RequestFormProps, T.Outter>(
  entityDetailEnhancer<T.RequestEnhancerProps<T.Request>, T.Request>({
    getEntity: getRequest,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: myRequestsLabel, to: myRequestsPath },
    { label: get(entity, 'id') ? 'Upravit záznam' : 'Nový záznam' }
  ]),
  withProps<{}, T.RequestProps>(({ entity }) => ({
    initialValues: {
      ...entity
    }
  })),
  reduxForm({
    form: 'module-requests'
  })
);

export const View: React.SFC<T.Outter & T.RequestFormProps> = props => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <MyRequestsFormBasic />
      </Card>
    </form>
  </div>
);

export const RequestsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/requests/my-requests/myRequestsForm.tsx